import { render, staticRenderFns } from "./BlogPostsEdit.vue?vue&type=template&id=79125e33&"
import script from "./BlogPostsEdit.vue?vue&type=script&lang=js&"
export * from "./BlogPostsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports